<template>
  <div>
    <ContentHeader title="Edit Profile" />
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <div class="card card-primary">
              <form @submit.prevent="handleCreateData()" class="card-body">
                <div
                  v-if="user.name == '' || user.pic == '' || user.phone == ''"
                  class="alert alert-danger"
                  role="alert"
                >
                  Update your Name, PIC and Phone first.
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="mb-3">
                      <div class="form-group mb-0">
                        <label for="username">Username</label>
                        <input
                          type="text"
                          class="form-control"
                          id="username"
                          placeholder="Enter Username"
                          :class="{
                            'border-danger': $v.payload.username.$error,
                          }"
                          v-model="payload.username"
                          disabled
                        />
                      </div>
                      <div
                        class="text-danger"
                        v-if="$v.payload.username.$error"
                      >
                        <small>Username Required</small>
                      </div>
                    </div>
                    <div class="mb-3">
                      <div class="form-group mb-0">
                        <label for="name">Name</label>
                        <input
                          type="text"
                          class="form-control"
                          id="name"
                          placeholder="Enter Name"
                          :class="{ 'border-danger': $v.payload.name.$error }"
                          v-model="payload.name"
                        />
                      </div>
                      <div class="text-danger" v-if="$v.payload.name.$error">
                        <small>Name Required</small>
                      </div>
                    </div>
                    <div class="mb-3">
                      <div class="form-group mb-0">
                        <label for="email">Email</label>
                        <input
                          type="text"
                          class="form-control"
                          id="email"
                          placeholder="Enter Email"
                          :class="{ 'border-danger': $v.payload.email.$error }"
                          v-model="payload.email"
                          disabled
                        />
                      </div>
                      <div class="text-danger" v-if="$v.payload.email.$error">
                        <small>Email Required</small>
                      </div>
                    </div>

                    <div class="mb-3">
                      <div class="form-group mb-0">
                        <label for="pic">PIC</label>
                        <input
                          type="text"
                          class="form-control"
                          id="pic"
                          placeholder="Enter Pic"
                          :class="{ 'border-danger': $v.payload.pic.$error }"
                          v-model="payload.pic"
                        />
                      </div>
                      <div class="text-danger" v-if="$v.payload.pic.$error">
                        <small>PIC Required</small>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <div class="form-group mb-0">
                        <label for="address">Address</label>
                        <input
                          type="text"
                          class="form-control"
                          id="address"
                          placeholder="Enter Address"
                          :class="{
                            'border-danger': $v.payload.address.$error,
                          }"
                          v-model="payload.address"
                        />
                      </div>
                      <div class="text-danger" v-if="$v.payload.address.$error">
                        <small>Address Required</small>
                      </div>
                    </div>
                    <div class="mb-3">
                      <div class="form-group mb-0">
                        <label for="phone">Phone</label>
                        <vue-tel-input
                          v-model="payload.phone"
                          :autoDefaultCountry="false"
                          @validate="validatePhone"
                          @country-changed="countryChanged"
                          @input="validateFirstLetter"
                          :class="{
                            'border-danger':
                              !phoneValid ||
                              !$v.payload.phone.required ||
                              !$v.payload.phone.checkData,
                          }"
                        ></vue-tel-input>
                      </div>
                      <div
                        class="text-danger"
                        v-if="!phoneValid || !$v.payload.phone.checkData"
                      >
                        <small>Phone Number is invalid</small>
                      </div>
                      <div
                        class="text-danger"
                        v-if="!$v.payload.phone.required"
                      >
                        <small>Phone Required</small>
                      </div>
                    </div>
                    <div class="mb-3">
                      <div class="form-group mb-0">
                        <label for="country">Country</label>
                        <country-select
                          v-model="payload.country"
                          :country="payload.country"
                          topCountry="ID"
                          countryName="true"
                          :class="{
                            'border-danger': $v.payload.country.$error,
                          }"
                          class="form-control"
                          id="country"
                        />
                      </div>
                      <div class="text-danger" v-if="$v.payload.country.$error">
                        <small>Country Required</small>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="mb-3">
                  <div class="form-group mb-0">
                    <label for="image">Image</label>
                    <div class="row">
                      <div class="col-md-7">
                        <small class="text-secondary">*Preview</small>
                        <div class="image-group">
                          <label for="image" class="image-upload-label rounded">
                            <i class="fas fa-edit"></i>
                          </label>
                          <img
                            :src="preview_image"
                            class="rounded preview-image"
                            :class="{
                              'image-exist': img,
                              'border border-danger': image_validation_message,
                            }"
                          />
                        </div>
                      </div>
                    </div>
                    <input
                      type="file"
                      class="d-none"
                      id="image"
                      placeholder="Enter Image"
                      @change="handleImageUpload($event)"
                      accept="image/png, image/jpeg"
                    />
                  </div>
                  <div class="text-danger" v-if="image_validation_message">
                    <small>{{ image_validation_message }}</small>
                  </div>
                </div>
                <div class="card-footer">
                  <router-link
                    class="btn btn-outline-danger mr-3"
                    :to="{ name: 'Profile' }"
                    v-if="!userFieldStatus"
                  >
                    Back
                  </router-link>
                  <button
                    type="submit"
                    href="#"
                    class="btn btn-success btn-block d-flex align-items-center justify-content-center"
                    :disabled="submitStatus === 'PENDING'"
                  >
                  <div v-if="loading" class="spinner-border text-light me-2" role="status"></div>
                    Save
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </section>
    <b-modal
      id="crop-modal"
      ref="crop-modal"
      centered
      title="BootstrapVue"
      hide-footer
      hide-header
    >
      <cropper
        :class="{
          'image-exist': img,
          'border-danger': image_validation_message,
        }"
        class="cropper rounded image-cropper-style"
        :src="img"
        :autoZoom="false"
        :stencil-props="{
          aspectRatio: 1 / 1,
        }"
        ref="cropper"
      />
      <div class="py-3 row">
        <div class="col-6">
          <button
            class="btn btn-outline-danger w-100"
            @click="hideModal('crop-modal')"
          >
            Close
          </button>
        </div>
        <div class="col-6">
          <button class="btn btn-success w-100" @click="getImageCropped()">
            Ok
          </button>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import apiVendor from "@/services/VendorApiServices";
import ContentHeader from "@/components/molecules/ContentHeader.vue";
import { required, helpers } from "vuelidate/lib/validators";
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

const checkData = helpers.regex("checkData", /^[0-9+ ]+$/);

export default {
  components: {
    ContentHeader,
    Cropper,
  },
  data() {
    return {
      payload: {
        username: "",
        name: "",
        email: "",
        pic: "",
        address: "",
        phone: "",
        country: "",
        image: "",
      },
      phoneFirstTimeLoad: 0,
      phoneValid: null,
      preview_image: null,
      previous_image: null,
      img: null,
      image_validation_message: null,
      trade_report_label: "Choose File",
      submitStatus: null,
      loading: false,
    };
  },
  validations: {
    payload: {
      username: {
        required,
      },
      name: {
        required,
      },
      email: {
        required,
      },
      pic: {
        required,
      },
      address: {
        required,
      },
      phone: {
        required,
        checkData,
      },
      country: {
        required,
      },
    },
  },
  async mounted() {
    try {
      let response = await apiVendor.get(`${this.$route.params.id}`);
      let phoneCode = "";

      this.preview_image = response.data.data.image;
      this.previous_image = response.data.data.image;
      this.payload = response.data.data;

      phoneCode = response.data.data.phone.substring(0, 3);
      if (phoneCode == "+93") {
        this.phoneFirstTimeLoad++;
      }
      this.img = null;
      this.payload.image = "";
    } catch (error) {
      this.$toasted.show(error.message, {
        theme: "toasted-primary",
        position: "top-right",
        duration: 4000,
      });
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    userFieldStatus() {
      return this.$store.getters.userFieldStatus;
    },
  },
  methods: {
    countryChanged(country) {
      this.phoneFirstTimeLoad++;
      let countryCode = country.dialCode;

      if (this.phoneFirstTimeLoad > 2) {
        const myPromise = new Promise((resolve) => {
          resolve((this.payload.phone = ""));
        });

        myPromise.then(() => {
          this.payload.phone = `+${countryCode}`;
        });
      }
    },
    validatePhone(country) {
      this.phoneValid = country.valid;
    },
    validateFirstLetter() {
      if (this.payload.phone[0] != "+") {
        this.phoneValid = false;
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    handleImageUpload(event) {
      if (event.target.value == "") {
        this.preview_image = this.previous_image;
      }

      let file = event.target.files[0];
      if (!file) {
        this.image_validation_message = null;
        this.img = null;
        this.payload.image = "";
      } else {
        if (file.size <= 1024 * 1024 * 2) {
          if (
            file["type"] === "image/jpeg" ||
            file["type"] === "image/jpg" ||
            file["type"] === "image/png"
          ) {
            this.showModal("crop-modal");
            this.image_validation_message = null;
            this.img = URL.createObjectURL(event.target.files[0]);
          } else {
            this.image_validation_message =
              "This Field must be an image (.jpg, .jpeg, .png)";
            this.img = null;
          }
        } else {
          this.image_validation_message = "Image must be less than 2MB";
          this.img = null;
        }
      }
    },

    getImageCropped() {
      const { canvas } = this.$refs.cropper.getResult();

      this.payload.image = this.dataURLtoFile(
        canvas.toDataURL(),
        `${Date.now()}.jpg`
      );
      this.preview_image = URL.createObjectURL(this.payload.image);
      this.hideModal("crop-modal");
    },

    async handleCreateData() {
      this.loading = true
      let data = new FormData();
      // data.append("username", this.payload.username);
      data.append("name", this.payload.name);
      data.append("pic", this.payload.pic);
      data.append("address", this.payload.address);
      data.append("phone", this.payload.phone);
      data.append("country", this.payload.country);

      if (this.payload.image) {
        data.append("image", this.payload.image);
      }

      this.$v.$touch();
      if (this.phoneValid && !this.$v.$invalid) {
        this.submitStatus = "PENDING";

        try {
          await apiVendor.put(`${this.$route.params.id}/`, data);
          this.submitStatus = "OK";
          this.loading = false

          this.$swal("Updated!", "Profile Has Been Updated.", "success").then(
            () => {
              this.submitStatus = "OK";
              this.errorMessage = "";
              this.$router.push({ name: "Profile" });
            }
          );
        } catch (error) {
          this.submitStatus = "ERROR";
          this.loading = false

          this.$swal("Fail!", error.data.data.username[0], "error").then(() => {
            this.submitStatus = "ERROR";
            this.errorMessage = "";
          });
        }
      } else {
        this.submitStatus = "ERROR";
        this.loading = false
      }
    },
    showModal(modal) {
      this.$refs[modal].show();
    },
    hideModal(modal) {
      this.$refs[modal].hide();
    },
  },
};
</script>

<style scoped>
</style>